import React, { useEffect, useState } from 'react';
import firebaseMenuMaker from '../firebase-menumaker';

// Helper to group docs by shopId
function groupByShopId(docs) {
    return docs.reduce((acc, doc) => {
        const shopId = doc.shopId || 'No shopId';
        if (!acc[shopId]) acc[shopId] = [];
        acc[shopId].push(doc);
        return acc;
    }, {});
}

export default function Live() {
    const [docs, setDocs] = useState([]);
    const [editing, setEditing] = useState({});
    const [newDoc, setNewDoc] = useState({
        id: '',
        name: '',
        shopId: '',
        timezone: '',
        version: '',
        'slides.0.name': '',
        'slides.0.url': '',
    });
    const [creating, setCreating] = useState(false);

    useEffect(() => {
        const db = firebaseMenuMaker.database();
        const ref = db.ref('hidethetv');
        const handleValue = snapshot => {
            const data = snapshot.val() || {};
            const docsArr = Object.entries(data).map(([id, value]) => ({ id, ...value }));
            setDocs(docsArr);
        };
        ref.on('value', handleValue);
        return () => ref.off('value', handleValue);
    }, []);

    const handleChange = (docId, attr, value) => {
        setEditing(prev => ({
            ...prev,
            [docId]: { ...prev[docId], [attr]: value }
        }));
    };

    const handleSave = async (docId) => {
        const db = firebaseMenuMaker.database();
        const updates = { ...editing[docId] };
        if (updates) {
            if ('slides.0.name' in updates || 'slides.0.url' in updates) {
                const slide0 = {
                    name: updates['slides.0.name'] !== undefined ? updates['slides.0.name'] : (docs.find(d => d.id === docId)?.slides?.[0]?.name ?? ''),
                    url: updates['slides.0.url'] !== undefined ? updates['slides.0.url'] : (docs.find(d => d.id === docId)?.slides?.[0]?.url ?? ''),
                };
                updates.slides = [slide0];
                delete updates['slides.0.name'];
                delete updates['slides.0.url'];
            }
            await db.ref(`hidethetv/${docId}`).update(updates);
            setEditing(prev => {
                const newEditing = { ...prev };
                delete newEditing[docId];
                return newEditing;
            });
        }
    };

    // Handle shopId editing
    const handleShopIdChange = (docId, value) => {
        setEditing(prev => ({
            ...prev,
            [docId]: { ...prev[docId], shopId: value }
        }));
    };

    // New doc handlers
    const handleNewDocChange = (attr, value) => {
        setNewDoc(prev => ({
            ...prev,
            [attr]: value
        }));
    };

    const handleCreate = async () => {
        if (!newDoc.id) return;
        const db = firebaseMenuMaker.database();
        const docData = {
            name: newDoc.name,
            shopId: newDoc.shopId,
            timezone: newDoc.timezone,
            version: newDoc.version,
            slides: [{
                name: newDoc['slides.0.name'],
                url: newDoc['slides.0.url'],
            }],
        };
        await db.ref(`hidethetv/${newDoc.id}`).set(docData);
        setNewDoc({
            id: '',
            name: '',
            shopId: '',
            timezone: '',
            version: '',
            'slides.0.name': '',
            'slides.0.url': '',
        });
        setCreating(false);
    };

    const grouped = groupByShopId(docs);

    return (
        <div>
            <h2>/hidethetv Documents</h2>
            <div style={{ marginBottom: 32, border: '1px solid #aaa', padding: 16 }}>
                {!creating ? (
                    <button onClick={() => setCreating(true)}>Create New Document</button>
                ) : (
                    <div>
                        <h3>Create New Document</h3>
                        <div>
                            <label>
                                Key (id):
                                <input
                                    value={newDoc.id}
                                    onChange={e => handleNewDocChange('id', e.target.value)}
                                />
                            </label>
                        </div>
                        <div>
                            <label>
                                shopId:
                                <input
                                    value={newDoc.shopId}
                                    onChange={e => handleNewDocChange('shopId', e.target.value)}
                                />
                            </label>
                        </div>
                        <div>
                            <label>
                                name:
                                <input
                                    value={newDoc.name}
                                    onChange={e => handleNewDocChange('name', e.target.value)}
                                />
                            </label>
                        </div>
                        <div>
                            <label>
                                timezone:
                                <input
                                    value={newDoc.timezone}
                                    onChange={e => handleNewDocChange('timezone', e.target.value)}
                                />
                            </label>
                        </div>
                        <div>
                            <label>
                                version:
                                <input
                                    value={newDoc.version}
                                    onChange={e => handleNewDocChange('version', e.target.value)}
                                />
                            </label>
                        </div>
                        <div>
                            <label>
                                slides.0.name:
                                <input
                                    value={newDoc['slides.0.name']}
                                    onChange={e => handleNewDocChange('slides.0.name', e.target.value)}
                                />
                            </label>
                        </div>
                        <div>
                            <label>
                                slides.0.url:
                                <input
                                    value={newDoc['slides.0.url']}
                                    onChange={e => handleNewDocChange('slides.0.url', e.target.value)}
                                />
                            </label>
                        </div>
                        <div>
                            {(newDoc['slides.0.url']) && (
                                <img
                                    src={newDoc['slides.0.url']}
                                    alt="Slide 0"
                                    style={{ width: 100, height: 60, objectFit: 'cover', border: '1px solid #aaa', marginTop: 8 }}
                                />
                            )}
                        </div>
                        <button onClick={handleCreate} disabled={!newDoc.id}>Create</button>
                        <button onClick={() => setCreating(false)} style={{ marginLeft: 8 }}>Cancel</button>
                    </div>
                )}
            </div>
            {Object.entries(grouped).map(([shopId, shopDocs]) => (
                <div key={shopId} style={{ marginBottom: 40 }}>
                    <h3 style={{
                        backgroundColor: 'lightblue',
                    }}>shopId: {shopId}</h3>
                    <ul>
                        {shopDocs.map(docItem => (
                            <li key={docItem.id} style={{ marginBottom: 20, border: '1px solid #ccc', padding: 10 }}>
                                <div><strong>Key:</strong> {docItem.id}</div>
                                <div>
                                    <a href={`https://api.hidethellama.com/tvs/${docItem.id}/0`}>data</a>
                                </div>
                                <div>
                                    <label>
                                        shopId:
                                        <input
                                            value={editing[docItem.id]?.shopId ?? docItem.shopId ?? ''}
                                            onChange={e => handleShopIdChange(docItem.id, e.target.value)}
                                        />
                                    </label>
                                </div>
                                <div>
                                    <label>
                                        name:
                                        <input
                                            value={editing[docItem.id]?.name ?? docItem.name ?? ''}
                                            onChange={e => handleChange(docItem.id, 'name', e.target.value)}
                                        />
                                    </label>
                                </div>
                                <div>
                                    <label>
                                        timezone:
                                        <input
                                            value={editing[docItem.id]?.timezone ?? docItem.timezone ?? ''}
                                            onChange={e => handleChange(docItem.id, 'timezone', e.target.value)}
                                        />
                                    </label>
                                </div>
                                <div>
                                    <label>
                                        version:
                                        <input
                                            value={editing[docItem.id]?.version ?? docItem.version ?? ''}
                                            onChange={e => handleChange(docItem.id, 'version', e.target.value)}
                                        />
                                    </label>
                                </div>
                                <div>
                                    <label>
                                        slides.0.name:
                                        <input
                                            value={
                                                editing[docItem.id]?.['slides.0.name'] ??
                                                (docItem.slides && docItem.slides[0]?.name) ??
                                                ''
                                            }
                                            onChange={e => handleChange(docItem.id, 'slides.0.name', e.target.value)}
                                        />
                                    </label>
                                </div>
                                <div>
                                    <label>
                                        slides.0.url:
                                        <input
                                            value={
                                                editing[docItem.id]?.['slides.0.url'] ??
                                                (docItem.slides && docItem.slides[0]?.url) ??
                                                ''
                                            }
                                            onChange={e => handleChange(docItem.id, 'slides.0.url', e.target.value)}
                                        />
                                    </label>
                                </div>
                                <div>
                                    {((editing[docItem.id]?.['slides.0.url'] ?? docItem.slides?.[0]?.url) && (
                                        <img
                                            src={editing[docItem.id]?.['slides.0.url'] ?? docItem.slides?.[0]?.url}
                                            alt="Slide 0"
                                            style={{ width: 100, height: 60, objectFit: 'cover', border: '1px solid #aaa', marginTop: 8 }}
                                        />
                                    ))}
                                </div>
                                <button onClick={() => handleSave(docItem.id)}>Save</button>
                            </li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
    );
}
